import { Sparkles, ArrowRight, MessageCircle } from 'lucide-react';

interface Props {
  index: number;
}

export function RoadmapCTACheckpoint({ index }: Props) {
  const mailto =
    'mailto:cscdigitalization@gmail.com' +
    '?subject=' +
    encodeURIComponent('DOP Roadmap — Pain point I\'d like digitised') +
    '&body=' +
    encodeURIComponent(
      "Hi DOP team,\n\nHere's a workflow I'd love to see on the roadmap:\n\n" +
        '• What I do today:\n' +
        '• Why it slows me down:\n' +
        '• How often it happens:\n\nThanks!'
    );

  return (
    <div
      className="relative pl-16"
      style={{
        animation: 'roadmap-fade-up 0.5s ease-out backwards',
        animationDelay: `${index * 80}ms`,
      }}
    >
      <span
        aria-hidden
        className="absolute left-2 top-2 flex h-10 w-10 items-center justify-center rounded-full border-2 border-dashed border-capitol-red-300 bg-card"
      >
        <Sparkles className="h-5 w-5 text-capitol-red-500" />
      </span>

      <div className="group relative overflow-hidden rounded-2xl border-2 border-dashed border-capitol-red-200 bg-gradient-to-br from-capitol-red-50/50 via-card to-warning/10 p-6 transition-all duration-300 hover:-translate-y-0.5 hover:border-capitol-red-300 hover:shadow-lg">
        <span
          aria-hidden
          className="pointer-events-none absolute -right-12 -top-12 h-32 w-32 rounded-full bg-capitol-red-500/10 blur-2xl"
        />
        <span
          aria-hidden
          className="pointer-events-none absolute -bottom-12 -left-12 h-32 w-32 rounded-full bg-warning/10 blur-2xl"
        />

        <div className="relative flex flex-col gap-4 sm:flex-row sm:items-start">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-white text-capitol-red-500 shadow-sm ring-1 ring-capitol-red-100">
            <MessageCircle className="h-6 w-6" />
          </span>

          <div className="min-w-0 flex-1">
            <span className="inline-flex items-center gap-1 rounded-full bg-capitol-red-500/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-capitol-red-500">
              <Sparkles className="h-3 w-3" />
              You decide what's next
            </span>
            <h3 className="mt-2 text-lg font-semibold leading-tight text-capitol-gray-500">
              What should we build next?
            </h3>
            <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">
              Got a workflow that's slow, manual, or error-prone? Tell the DOP team about it —
              your pain point could be the next milestone on this roadmap.
            </p>

            <div className="mt-4 flex flex-wrap items-center gap-2">
              <a
                href={mailto}
                className="inline-flex items-center gap-1.5 rounded-md bg-capitol-red-500 px-3.5 py-2 text-sm font-medium text-white shadow-sm transition-all hover:bg-capitol-red-600 hover:shadow-md"
              >
                Share a pain point
                <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" />
              </a>
              <span className="text-xs text-muted-foreground">
                or pull a DOP team member aside — both work.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
